export default "__VITE_ASSET__DElf4ZKa__"